import type { SxProps, Theme } from '@/ui/primitives/types';

export const loadErrorBannerSx = { border: 0 } satisfies SxProps<Theme>;
export const chartLoadErrorBannerSx = loadErrorBannerSx;
